import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import srcImg from "../../../../../styles/img/icon-participants.svg";
import _ from "lodash";
import ModaleParticipants from "./ModaleParticipants";
import { connect } from "react-redux";
import { getNextEventParticipants } from "./Next-event.ducks";

const IconParticipants = () => (
  <object
    data={srcImg}
    type="image/svg+xml"
    style={{
      width: "25px",
      height: "25px",
      pointerEvents: "none",
      cursor: "pointer",
    }}
    className="img-fluid"
  />
);
const NextEvent = (props) => {
  const { dataEvent } = props;
  const [modaleParticipants, showModaleParticipants] = useState(false);
  let tok = localStorage.getItem("token");

  function openParticipants() {
    props.getNextEventParticipants(tok);

    setTimeout(() => {
      showModaleParticipants(true);
    }, 500);
  }
  function closeParticipants() {
    showModaleParticipants(false);
  }
  if (!_.isEmpty(dataEvent.event.eventDetails)) {
    let event = dataEvent.event;
    return (
      <div className="bloc-event mt-4 box-shadow d-flex align-items-stretch">
        <div className="date-event d-flex align-items-center gradient">
          <div className="content">
            <span>
              {moment(event.eventDetails.dateTime, "YYYY-MM-DD").format("D")}
            </span>
            <p>
              {moment(event.eventDetails.dateTime, "YYYY-MM-DD").format("MMM")}
            </p>
          </div>
        </div>
        <div className="desc-event">
          <h3>{event.eventDetails.titre}</h3>
          <p>{`à partir de ${moment(event.eventDetails.dateTime).format(
            "HH[h]mm"
          )}`}</p>
          {event.eventDetails.participants === true ? (
            <a
              className="btn-white modalP"
              data-toggle="modal"
              data-target="#modalParticipants"
              onClick={openParticipants}
            >
              <IconParticipants />
              Participants
            </a>
          ) : (
            <a
              className="btn-white btn-no-bg"
              data-toggle="modal"
              data-target="#modalParticipants"
            >
              {" "}
              Pas de participants
            </a>
          )}
        </div>
        {modaleParticipants ? (
          <ModaleParticipants
            onCloseModaleParticipants={closeParticipants}
            event={event}
          />
        ) : (
          ""
        )}
      </div>
    );
  } else {
    return "";
  }
};
const mapStateToProps = ({ event }) => ({ event });

NextEvent.propTypes = {
  dataEvent: PropTypes.object,
};
const withStore = connect(mapStateToProps, { getNextEventParticipants });

export default withStore(NextEvent);
